import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const featureCategories = [
  {
    title: '✅ Required Disclosures',
    items: [
      'AB 1482 Rent Cap Notice',
      'Lead-Based Paint (pre-1978)',
      'Bed Bug Information',
      'Mold Disclosure',
      'And 15+ more...',
    ],
  },
  {
    title: '🏠 Property Types',
    items: [
      'Single Family Homes',
      'Apartments & Condos',
      'Duplexes & Triplexes',
      'Mobile Homes',
      'ADUs & In-law Units',
    ],
  },
  {
    title: '📱 Modern Features',
    items: [
      'Digital E-Signatures',
      'PDF Download & Archive',
      'Email Delivery',
      'Mobile Friendly',
      'Cloud Storage',
    ],
  },
];

const FeaturesDeepDiveSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 60, fontWeight: 700 }}>
          Everything You Need, Nothing You Don't
        </h2>
        <div className="features-grid">
          {featureCategories.map((category, idx) => (
            <div 
              className="feature-card" 
              key={idx}
              style={{
                padding: '30px',
                border: '2px solid var(--border)',
                borderRadius: '12px',
                background: 'transparent',
                height: '100%',
              }}
            >
              <h3 style={{ color: 'var(--primary)', marginBottom: '15px', fontSize: '1.25rem', fontWeight: 600 }}>
                {category.title}
              </h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {category.items.map((item, itemIdx) => (
                  <li key={itemIdx} style={{ color: 'var(--text-light)', lineHeight: 1.8 }}>
                    • {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default FeaturesDeepDiveSection; 